import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { DeviceService } from 'app/services/device.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { environment } from 'environments/environment';

@Injectable()
export class WebViewGuard implements CanActivate {
    private logger: Logger;
    constructor(
        loggerFactory: LoggerFactory,
        private deviceService: DeviceService) {
        this.logger = loggerFactory.create('WebViewGuard');
    }

    public async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        try {
            this.logger.debug('Opening web view for current user.');
            const result = await this.deviceService.createWebView();
            const appUrl = `${environment.webAppUrl}/auth/${result.customToken}`;
            window.location.href = appUrl;
        } catch (err) {
            this.logger.error('An error occured while loading web view.');
            window.close();
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/devices/web-view/web-view.guard.ts